<template>
  <div class="department-tab shared-index">
    <el-row class="table-title" type="flex" align="center">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleChangeTab">
          <el-tab-pane name="department">
            <div slot="label">
              Phòng ban
              <span v-if="activeTab === 'department'">({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          @click="createDepartment"
        >Thêm</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          size="small"
          @click="handleChangeTab"
        >Làm mới</el-button>
      </div>
    </el-row>
    <list-department
      :loading="callingAPI"
      :data="allDepartment"
      @reload="handleReloadAfterDelete"
      @update="updateDepartment"
    />
    <el-row type="flex" justify="end" class="my-4">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>
    <update-department-popup
      v-if="visibleUpdate"
      :department="selectedDepartment"
      :visible="visibleUpdate"
      @close="visibleUpdate = false"
      @reload="loadData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ListDepartment from './components/List.vue'
import UpdateDepartmentPopup from './components/popup/Update.vue'
import { getTranslation } from '@/utils/filters'
import { getDepartments } from '@/services/department'

export default {
  name: 'Department',
  components: {
    ListDepartment,
    UpdateDepartmentPopup
  },
  data() {
    return {
      visibleUpdate: false,
      callingAPI: false,
      allDepartment: [],
      selectedDepartment: {},
      activeTab: 'department',
      total: 0,
      limit: 10,
      page: 1,
      searchText: ''
    }
  },
  computed: {
    ...mapGetters(['language']),
    params() {
      const p = {
        page: this.page,
        per_page: this.limit,
        locale: this.language
      }
      return p
    }
  },
  watch: {
    language: 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.callingAPI = true
      this.visibleUpdate = false
      getDepartments(this.params, this.activeTab).then((response) => {
        this.allDepartment = response.result.map((r) => ({
          ...r,
          name: getTranslation(r, this.language) ? getTranslation(r, this.language).name : r.name
        }))
        this.total = response.total
        this.callingAPI = false
      }).catch(() => {
        this.callingAPI = false
      })
    },
    handleChangePage(page) {
      this.page = page
      this.loadData()
    },
    createDepartment() {
      this.selectedDepartment = null
      this.visibleUpdate = true
    },
    updateDepartment(data) {
      this.selectedDepartment = data
      this.visibleUpdate = true
    },
    handleChangeTab() {
      this.page = 1
      this.loadData()
    },
    handleReloadAfterDelete() {
      if (this.allDepartment.length === 1 && this.page > 1) {
        this.page = this.page - 1
      }
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.department-tab {
  .table-title {
    &__left {
      max-width: calc(100% - 200px);
      .el-tabs {
        max-width: 100%;
      }
    }
  }
}
</style>
